
export default function PreviousAlbum() {
  const streamLinks = [
    {
      name: 'Spotify',
      icon: 'ri-spotify-fill',
      link: 'https://open.spotify.com/album/628RYfi6grfGn6z0lU80tR?referral=labelaffiliate&utm_source=1011lBPbcChg&utm_medium=Indie_Distrokid&utm_campaign=labelaffiliate',
    },
    {
      name: 'Apple Music',
      icon: 'ri-apple-fill',
      link: 'https://music.apple.com/us/album/chicago-heartbreak/1855286290?uo=4&app=music&at=1001lry3&ct=dashboard',
    },
    {
      name: 'YouTube',
      icon: 'ri-youtube-fill',
      link: 'https://youtube.com/channel/UCF5GtB4OAv1llPWErmV-Img?si=AGjt8lm0jYIuPoV-',
    },
    {
      name: 'iHeart',
      icon: 'ri-heart-fill',
      link: 'https://www.iheart.com/artist/etc-30048583/albums/chicago-heartbreak-361847219',
    },
    {
      name: 'Tidal',
      icon: 'ri-music-fill',
      link: 'https://tidal.com/album/475112068/u',
    },
    {
      name: 'iTunes',
      icon: 'ri-apple-fill',
      link: 'https://music.apple.com/us/album/chicago-heartbreak/1855286290',
    },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm uppercase tracking-[0.3em] text-red-500 font-semibold mb-3">
            Previous Release
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-white">
            CHICAGO HEARTBREAK
          </h2>
        </div>

        <div className="grid md:grid-cols-5 gap-10 items-center">
          {/* Album Cover */}
          <div className="md:col-span-2 relative group">
            <div className="absolute inset-0 bg-red-600/15 blur-2xl group-hover:bg-red-600/25 transition-all duration-500"></div>
            <div className="relative w-full aspect-square overflow-hidden">
              <img
                src="https://static.readdy.ai/image/f2e9d0ecb0c8da9b7a5f1d855b73822d/8b5cb6665a72ec64dfbad927512cfad2.png"
                alt="Chicago Heartbreak Album Cover"
                className="w-full h-full object-cover object-top shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500"
              />
            </div>
          </div>

          {/* Album Info */}
          <div className="md:col-span-3">
            <div className="space-y-5">
              <div>
                <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">
                  E.T.C — Debut Album
                </p>
                <h3 className="text-3xl font-black text-white">CHICAGO HEARTBREAK</h3>
              </div>

              <p className="text-gray-300 text-base leading-relaxed max-w-xl">
                The 2025 debut project that started it all.{' '}
                <strong className="text-white">Chicago Heartbreak</strong> is a raw,
                unfiltered journey through love, loss, and the grit of growing up
                in the Chi. Dark beats, honest lyrics, and the emotional depth that
                defines E.T.C's sound.
              </p>

              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 bg-zinc-900 border border-zinc-700 text-gray-300 text-sm font-semibold">
                  R&amp;B
                </span>
                <span className="px-4 py-2 bg-zinc-900 border border-zinc-700 text-gray-300 text-sm font-semibold">
                  HIP-HOP
                </span>
                <span className="px-4 py-2 bg-zinc-900 border border-zinc-700 text-gray-300 text-sm font-semibold">
                  ALTERNATIVE
                </span>
              </div>

              {/* Stream Links */}
              <div className="pt-4">
                <p className="text-xs uppercase tracking-widest text-gray-500 mb-4">
                  Stream Now
                </p>
                <div className="flex flex-wrap gap-3">
                  {streamLinks.map((platform) => (
                    <a
                      key={platform.name}
                      href={platform.link}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="flex items-center gap-2 px-4 py-2.5 bg-zinc-900/80 border border-zinc-800 hover:border-red-600 text-gray-400 hover:text-white transition-all duration-300 cursor-pointer"
                    >
                      <i
                        className={`${platform.icon} text-lg w-5 h-5 flex items-center justify-center`}
                      ></i>
                      <span className="text-sm font-semibold whitespace-nowrap">
                        {platform.name}
                      </span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
